import script from "./CardHouse.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardHouse.vue?vue&type=script&setup=true&lang=ts"

import "./CardHouse.vue?vue&type=style&index=0&id=58959cc8&lang=less"

const __exports__ = script;

export default __exports__